import { Link } from 'react-router-dom';
import type { CategoryItem } from '@/mocks/home';

interface CategorySectionProps {
  categories: CategoryItem[];
}

const iconMap: Record<string, string> = {
  'ri-heart-line': 'ri-heart-line',
  'ri-magic-line': 'ri-magic-line',
  'ri-sword-line': 'ri-sword-line',
  'ri-search-eye-line': 'ri-search-eye-line',
  'ri-emotion-laugh-line': 'ri-emotion-laugh-line',
  'ri-film-line': 'ri-film-line',
  'ri-ghost-line': 'ri-ghost-line',
  'ri-building-line': 'ri-building-line',
  'ri-briefcase-line': 'ri-briefcase-line',
  'ri-ancient-gate-line': 'ri-ancient-gate-line',
  'ri-basketball-line': 'ri-basketball-line',
  'ri-loop-left-line': 'ri-loop-left-line',
};

export default function CategorySection({ categories }: CategorySectionProps) {
  return (
    <section className="py-14 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900">
            漫画分类
          </h2>
          <p className="mt-2 text-sm text-foreground-500">按类型浏览，快速找到你喜欢的韩漫</p>
        </div>

        <div className="grid grid-cols-3 sm:grid-cols-4 md:grid-cols-6 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group flex flex-col items-center gap-3 p-4 md:p-5 rounded-xl bg-background-50 hover:bg-primary-100/50 transition-all duration-200 cursor-pointer"
            >
              <div className="w-12 h-12 md:w-14 md:h-14 flex items-center justify-center rounded-full bg-primary-100 text-primary-600 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                <i className={`${iconMap[cat.icon] || 'ri-bookmark-line'} text-xl md:text-2xl`}></i>
              </div>
              <div className="text-center">
                <span className="text-sm font-medium text-foreground-800 group-hover:text-primary-700 transition-colors whitespace-nowrap">
                  {cat.name}
                </span>
                <p className="text-xs text-foreground-400 mt-0.5">{cat.count}部</p>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}